import React, { useState } from 'react'
import { Header, MainButton } from '../../Components/index'
import worker from '../../assets/Images/worker.png'
import { Button } from 'antd'
import { AiOutlineArrowUp } from 'react-icons/ai';
const Roof = (props) => {
    const { setMap, setRoof } = props
    const [isOpen, setIsOpen] = useState(false);
    const [consumption, setConsumption] = useState(null);
    const [selectedOption, setSelectedOption] = useState("Choisir une option");
    const [selectedValue, setSelectedValue] = useState("");

    const [currentDirection, setCurrentDirection] = useState('north');
    const options = ["30°", "40°", "50°"];
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        let event = option
        setSelectedValue(event)
        let opt
        if (event == '30°') {
            opt = 1
        } else if (event == '40°') {
            opt = 2
        } else if (event == '50°') {
            opt = 3
        }

        setIsOpen(false)
        console.log('selectedValue', event)
    };
    return (
        <>
            <div>
                <Header heading='Simulez votre projet photovoltaique !' />
                <div className='inner_div '>
                    <div className='worker_div' >
                        <img src={worker} className='worker_img' />
                    </div>
                    <div className='section_container roof_section '>
                        <div className="section">
                            <div className='step_progress stepRoof'>
                                <div className='address_step'></div>
                                <div className='address_step'></div>
                                <div className='address_step'></div>
                                <div className='step'></div>
                            </div>

                            <div className="Roof_main_div">
                                <div className="roof_div">
                                    <div className="roofHeading">
                                        <h2>Quelle est l’exposition de votre toiture ?</h2>
                                    </div>
                                    <div className="right_Section">
                                        <div className="direction_div">
                                            <div onClick={() => setCurrentDirection('north-west')}>
                                                <span className='direction'>Nord Ouest</span>
                                            </div>
                                            <div onClick={() => setCurrentDirection('north')}> <span className='Main_directions'>Nord</span> </div>
                                            <div onClick={() => setCurrentDirection('north-east')}> <span className='direction'>Nord Est</span> </div>
                                        </div>
                                        <div className="arrow_div">
                                            <div onClick={() => setCurrentDirection('west')}> <span className='Main_directions'>Ouest</span> </div>
                                            <div><span className='direction'><AiOutlineArrowUp className={`arrow ${currentDirection}`} /></span></div>
                                            <div onClick={() => setCurrentDirection('east')} > <span className='Main_directions '>Est</span> </div>
                                        </div>
                                        <div className="direction_div">
                                            <div onClick={() => setCurrentDirection('south-west')}> <span className='direction'>Sud Ouest</span> </div>
                                            <div onClick={() => setCurrentDirection('south')}> <span className='Main_directions'>Sud</span> </div>
                                            <div onClick={() => setCurrentDirection('south-east')}> <span className='direction'>Sud Est</span> </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="roof_div">
                                    <div className="roofHeading">
                                        <h2>Quelle est l’inclinaison votre toit en degré ?</h2>
                                    </div>
                                    <div className="right_Section">
                                        <div className="dropdown">
                                            <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                                                {selectedOption}
                                            </div>
                                            {isOpen && (
                                                <ul className="dropdown-list Roof_list" >
                                                    {options?.map((option) => (
                                                        <li key={option} onClick={() => handleOptionClick(option)} className='dropdownli'>
                                                            {option}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="roof_div">
                                    <div className="roofHeading">
                                        <h2>Quelle est votre consommation énérgétique annuelle ?</h2>
                                    </div>
                                    <div className="right_Section">
                                        <div>
                                            <input onChange={(e) => setConsumption(e?.target?.value)} className='RooF_inp' placeholder='En Kwh' />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className=' roof_main_btn'>
                                <div className="Button_div" onClick={() => setMap(false)}>
                                    <Button className='map_btn roofPrécédent'>Précédent</Button>
                                </div>
                                <div onClick={() => setRoof(true)}>
                                    <MainButton disabled={consumption && selectedValue? false : true} title='Suivant' />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Roof
